import { ModuleWithProviders, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ConfigureGroupComponent } from './configure_group.component';
import { AuthGuard, SharedModule } from '../../../shared';
import { ConfigGroupService } from './group.service';

const configureGroupRouting: ModuleWithProviders = RouterModule.forChild([
  {
    path: 'setting/dfb/config/group',
    component: ConfigureGroupComponent,
    canActivate: [AuthGuard],
    pathMatch: 'full'
  }
]);

@NgModule({
  imports: [  
    SharedModule,
    configureGroupRouting,
    NgbModule
  ],
  declarations: [
    ConfigureGroupComponent
  ],
  providers: [
 ConfigGroupService
  ],
})
export class ConfigureGroupModule {}




// WEBPACK FOOTER //
// ./src/app/system_setting/DFB/configur_group/group.module.ts